import React from 'react';
import { cn } from '../../lib/utils';
import * as LuIcons from 'react-icons/lu';
import SafeIcon from '../../common/SafeIcon';

const { LuX } = LuIcons;

export function Modal({ isOpen, onClose, title, children, className, style }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-slate-900/50 p-4 backdrop-blur-sm">
      <div className="fixed inset-0" onClick={onClose} aria-hidden="true" />
      <div
        className={cn(
          "relative w-full max-w-md transform rounded-2xl bg-white shadow-2xl transition-all my-4",
          className
        )}
        style={style}
      >
        {/* Sticky header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-white rounded-t-2xl sticky top-0 z-10">
          <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
          <button
            onClick={onClose}
            className="rounded-full p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
          >
            <SafeIcon icon={LuX} size={20} />
          </button>
        </div>
        {/* Content */}
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>
  );
}